// Radiation Exposure units with conversion factors to coulomb/kilogram (C/kg)
export const radiationExposureUnits = [
  { id: 'coulomb-per-kilogram', name: 'Coulomb/Kilogram', symbol: 'C/kg', plural: 'Coulombs/Kilogram', factor: 1 },
  { id: 'millicoulomb-per-kilogram', name: 'Millicoulomb/Kilogram', symbol: 'mC/kg', plural: 'Millicoulombs/Kilogram', factor: 1e-3 },
  { id: 'microcoulomb-per-kilogram', name: 'Microcoulomb/Kilogram', symbol: 'µC/kg', plural: 'Microcoulombs/Kilogram', factor: 1e-6 },
  { id: 'roentgen', name: 'Roentgen', symbol: 'R', plural: 'Roentgens', factor: 2.58e-4 },
  { id: 'milliroentgen', name: 'Milliroentgen', symbol: 'mR', plural: 'Milliroentgens', factor: 2.58e-7 },
  { id: 'microroentgen', name: 'Microroentgen', symbol: 'µR', plural: 'Microroentgens', factor: 2.58e-10 },
  { id: 'parker', name: 'Parker', symbol: 'parker', plural: 'Parkers', factor: 2.58e-4 },
  { id: 'rep', name: 'Rep', symbol: 'rep', plural: 'Reps', factor: 2.58e-4 },
];

export const popularRadiationExposureConversions = [
  { from: 'coulomb-per-kilogram', to: 'roentgen' },
  { from: 'roentgen', to: 'coulomb-per-kilogram' },
  { from: 'roentgen', to: 'milliroentgen' },
  { from: 'milliroentgen', to: 'microroentgen' },
  { from: 'coulomb-per-kilogram', to: 'millicoulomb-per-kilogram' },
];

export const getUnitById = (id) => radiationExposureUnits.find(unit => unit.id === id);

export const convertRadiationExposure = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert radiation exposure units and learn the conversion formula.`;
};
